/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type ServiceDeskLiveChatEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const serviceDeskLiveChatEntryPoint: EntryPoint<ServiceDeskLiveChatEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<ServiceDeskLiveChatEntryPointComponent>(
			/* webpackChunkName: "async-service-desk-live-chat", jiraSpaEntry: "async-service-desk-live-chat" */ './ServiceDeskLiveChatSpa.tsx',
		),
		getPreloadProps: () => ({}),
	});
